import React from 'react'
import * as pkg from '../../../package.json'

const InfoVersion = () => (
  <p className="info-version">v{pkg.version}</p>
)

export default InfoVersion
